import { Path } from 'enums';
import TransactionEntryModule from 'modules/transaction-entry/transaction-entry.module';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

const TransactionPage = () => {
  return (
    <Switch>
      <Route exact path={`${Path.Transaction}/entry`} component={TransactionEntryModule} />
    </Switch>
  );
};

export default TransactionPage;
